import React from 'react'

const CompanyCamLogo = () => {
  return (
    <img src="https://res.cloudinary.com/taptapquote/image/upload/v1641926710/paintscout/providers/companycam.png" />
  )
}
export default CompanyCamLogo
